import * as actionTypes from "../actions/actionTypes";

export const contentDetails = (state = {}, { type, data }) => {
    switch (type) {
        case actionTypes.CONTENT_DETAIL:
            return data;
        default:
            return state;
    }
};